import React, { useEffect } from 'react';
import gridIcon from '../../../../assets/DasboardIcons/grid.png';
import HeaderAvatar from '../../../../components/Avatar/HeaderAvatar';
import { useDocument } from '../../../../Pages/SpreadsheetContainer/documentInfoContex';
import AppLauncherModal from '../../../AppLauncher/AppLauncherModal';

const Header = ({
  viewMode,
  onChangeView,
  onToggleSidebar,
  sortDropdownOpen,
  onToggleSort,
  sortOptions = [],
  selectedSort,
  onSelectSort,
}) => {
  const { userInfo } = useDocument();

  // Close sort dropdown on outside click
  const dropdownRef = React.useRef(null);
  React.useEffect(() => {
    function handleClick(e) {
      if (sortDropdownOpen && dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        onToggleSort?.(); // toggle will close
      }
    }
    if (sortDropdownOpen) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [sortDropdownOpen, onToggleSort]);

  // avatar rendering moved to separate component

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <button className="header-toggle-btn" onClick={onToggleSidebar} aria-label="Toggle sidebar">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="header-toggle-icon"><path strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" /></svg>
          </button>
          <div className="header-brand">
            <img src={gridIcon} alt="Pad" className="header-brand-icon" />
            <span className="header-brand-text">Grid</span>
          </div>
        </div>
        <div className="header-right">
          <div className="header-sort-container" ref={dropdownRef}>
            <button
              onClick={onToggleSort}
              className={`header-sort-btn ${sortDropdownOpen ? 'header-sort-btn-active' : ''}`}
            >
              <svg className="header-sort-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 7h18M6 12h12M10 17h4" />
              </svg>
              {selectedSort?.label || 'Sort'}
              <svg className={`header-sort-chevron ${sortDropdownOpen ? 'header-sort-chevron-rotated' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {sortDropdownOpen && (
              <div className="header-sort-dropdown">
                {sortOptions.map(opt => {
                  const active = selectedSort?.id === opt.id;
                  return (
                    <button
                      key={opt.id}
                      onClick={() => onSelectSort?.(opt)}
                      className={`header-sort-option ${active ? 'header-sort-option-active' : ''}`}
                    >
                      <span>{opt.label}</span>
                      {active && (
                        <svg className="header-sort-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                        </svg>
                      )}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
          <div className="header-view-toggle">
            <button
              onClick={() => onChangeView('grid')}
              className={`header-view-btn ${viewMode === 'grid' ? 'header-view-btn-active' : ''}`}
              title="Grid view"
            >
              <svg className="header-view-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3 3h7v7H3V3zm0 11h7v7H3v-7zm11-11h7v7h-7V3zm0 11h7v7h-7v-7z" />
              </svg>
            </button>
            <div className="header-view-divider"></div>
            <button
              onClick={() => onChangeView('list')}
              className={`header-view-btn ${viewMode === 'list' ? 'header-view-btn-active' : ''}`}
              title="List view"
            >
              <svg className="header-view-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" />
              </svg>
            </button>
          </div>
          <AppLauncherModal/>
          {/* User Profile*/}
          <HeaderAvatar scale={0.8} />
        </div>
      </div>
    </header>
  );
};

export default Header;
